import { useState } from 'react';
import '../App.css';
import '../styles/eventsSection.css'
import 'react-responsive-modal/styles.css';

import { TTEvent } from '../types';

import DOMPurify from 'dompurify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

interface props {
    eventsData: TTEvent[];
}

function EventsSection({eventsData}: props) {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    return (
        <div className='events-section'>
            <div className='top-line'>
                <h1 className='event-page-title'>Our events</h1>
                <p>Labour in the City organise events with business and political leaders, intended to be a resource for the Party and bring together likeminded people to discuss ideas.</p>
            </div>
            <div className='events-search'>

            </div>
            {(eventsData && eventsData.length > 0) ? <div className='events-list'>
                {eventsData.map((event, key) => {
                    const sanitisedDescription = DOMPurify.sanitize(event.description);
                    return (
                        <div className='event-container' key={key} onClick={() => window.open(event.url, "_blank")}>
                            <div className='event-image'>
                                <img src={event.images.header} className='event-img' alt='image-logo'/>
                            </div>
                            <div className='event-centre'>
                                <h1 className='event-title'>{event.name}</h1>
                                <p>{event.venue.name}, {event.venue.postal_code}</p>
                                { screenWidth > 750 && <div dangerouslySetInnerHTML={{ __html: sanitisedDescription }}></div> }
                            </div>
                            { screenWidth > 750 && <div className='event-cta'>
                                <FontAwesomeIcon icon={faChevronRight} size='2x'/>
                            </div> }
                        </div>
                    )
                })}
            </div> : <h2>No events found.</h2>}
        </div>
    );
}

export default EventsSection;
